export const baseUrl = {
    development:
        process.env.DOMAIN_URL ||
        'http://bumble-bff-landing-lb.bumble-bff-web-services.common.k8s.mlan:8080',
    test:
        process.env.DOMAIN_URL ||
        'http://bumble-bff-landing-lb.bumble-bff-web-services.common.k8s.mlan:8080',
    production: process.env.DOMAIN_URL || 'https://bumble.com',
}[process.env.NODE_ENV];
